import { toUsaDateFormat, toUsaDateTimeFormat } from "./date";

export function formattedOrDefault<TValue, TResult>(
  value: TValue | null | undefined,
  formatter: (value: TValue) => TResult,
  defaultValue = "-",
): typeof defaultValue | TResult {
  return value == null ? defaultValue : formatter(value);
}

export function dateFormatter(date: Date | string): string {
  return toUsaDateFormat(new Date(date));
}

export function dateTimeFormatter(date: Date | string): string {
  return toUsaDateTimeFormat(new Date(date));
}

export function formatOrderedListItem(
  title: string,
  ...numbers: number[]
): string {
  return [numbers.join("."), title].join(" ");
}
